import commandVisitor from "./commandVisitor.js";
import createDirectoryDialog from "../widgets/commandWidgets/createDirectoryDialog.js";
import deleteEntriesDialog from "../widgets/commandWidgets/deleteEntriesDialog.js";
import editEntryPermissionsDialog from "../widgets/commandWidgets/editEntryPermissionsDialog.js";
import moveEntriesDialog from "../widgets/commandWidgets/moveEntriesDialog.js";
import NotifyUsersDialog from "../widgets/commandWidgets/NotifyUsersDialog.js";
import renameEntryDialog from "../widgets/commandWidgets/renameEntryDialog.js";

/**
 * `commandInputWidgetBuilderVisitor` is a concrete implementation of
 * `commandVisitor' used to build input dialog widgets for commands.
 */

/**
 * Todo: Add JSDoc comment
 */
function commandInputWidgetBuilderVisitor() {
	const that = commandVisitor();

	that.visitCreateDirectoryCommand = function (aCommand) {
		return createDirectoryDialog(aCommand);
	};

	that.visitDeleteCommand = function (aCommand) {
		return deleteEntriesDialog(aCommand);
	};

	that.visitDownloadCommand = function () {
		return null;
	};

	that.visitExportCommand = function () {
		return null;
	};

	that.visitMarkAsPreliminaryCommand = function () {
		return null;
	};

	that.visitEditEntryPermissionsCommand = function (aCommand) {
		return editEntryPermissionsDialog(aCommand);
	};

	that.visitMoveCommand = function (aCommand) {
		return moveEntriesDialog(aCommand);
	};

	that.visitRenameCommand = function (aCommand) {
		return renameEntryDialog(aCommand);
	};

	that.visitUploadCommand = function (_aCommand) {
		return null;
	};

	that.visitImportCommand = function (_aCommand) {
		return null;
	};

	that.visitAgencyImportCommand = function (_aCommand) {
		return null;
	};

	that.visitNotifyUsersCommand = function (aCommand) {
		return new NotifyUsersDialog(aCommand);
	};

	return that;
}

export default commandInputWidgetBuilderVisitor;
